import { AppTypes } from './type'

export enum DeviceType {
    Mobile,
    Desktop
}

export interface AppState {
    device: DeviceType
}

export const AppModule = {
    state: {
        device: DeviceType.Desktop
    } as AppState,
    getters: {},
    mutations: {},
    actions: {}
}
